import axiosInstance from "@/lib/axios";

export interface publicStats {
    students: number;
    institutions: number;
    simulations: number;
    areas: number;
}

/** Conteos agregados para la landing (endpoint público, sin autenticación). */
export const getPublicStats = async (): Promise<publicStats> => {
    const { data } = await axiosInstance.get<publicStats>("/public/stats/");
    return data;
};
